// src/dev/menu.ts
import { SCENARIOS } from './scenarios';

declare global {
  interface Window {
    reloadCenario: () => void;
  }
}

const menu = document.getElementById('scenario-menu')!;
const target = document.getElementById('render-target')!;
const titleEl = document.getElementById('current-title')!;

const snippetHtmlEl = document.getElementById('snippet-html'); // Elemento do snippet
const snippetScriptPreEl = document.getElementById('snippet-script'); // Elemento do script

/**
 * Gera o HTML para copiar e colar no Moodle
 */
function updateSnippet(id: string) {
  if (!snippetHtmlEl) return;

  // Usa textContent para exibir o código escapado, não renderizar
  snippetHtmlEl.textContent = `<div class="cenario-wrapper" data-cenario-map="${id}" style="min-height: 600px; position: relative; background: #f5f5f5;">
  <div style="display: flex; justify-content: center; align-items: center; height: 100%; color: #666;">
    <p>Carregando cenário interativo...</p>
  </div>
</div>`;
}

/**
 * Gera o HTML para carregar o script global no Moodle.
 */
function snippetScriptPre() {
  if (!snippetScriptPreEl) return;

  // Usa textContent para exibir o código escapado, não renderizar
  snippetScriptPreEl.textContent = `<!-- Instalação Global (Admin > Aparência > HTML Adicional) -->
<script type="module" src="${import.meta.env.VITE_CDN_URL}/app-unb-ecos/imunizamaisbrasil/latest/app.min.js"></script>`;
}

/**
 * Carrega um cenário na tela
 */
function loadScenario(scenario: (typeof SCENARIOS)[0]) {
  // Atualiza Títulos e UI
  titleEl.textContent = scenario.label;
  document.querySelectorAll('.menu-btn').forEach((b) => b.classList.remove('active'));

  const activeBtn = document.querySelector(`.menu-btn[data-id="${scenario.id}"]`);
  if (activeBtn) activeBtn.classList.add('active');

  // Atualiza o Snippet
  updateSnippet(scenario.id);

  // Força recriação do nó → MutationObserver
  target.innerHTML = '';

  setTimeout(() => {
    const wrapper = document.createElement('div');
    wrapper.className = 'cenario-wrapper';
    wrapper.dataset.cenarioMap = scenario.id;
    wrapper.style.minHeight = '500px';
    wrapper.style.position = 'relative';

    wrapper.innerHTML = `Carregando ${scenario.id}...`;
    target.appendChild(wrapper);
  }, 50);
}

// Agrupamento e renderização do menu
const grouped: Record<string, typeof SCENARIOS> = {};

for (const scenario of SCENARIOS) {
  if (!grouped[scenario.group]) {
    grouped[scenario.group] = [];
  }
  grouped[scenario.group].push(scenario);
}

Object.entries(grouped).forEach(([group, items]) => {
  const section = document.createElement('li');
  section.className = 'menu-section';
  section.textContent = group;
  menu.appendChild(section);

  items!.forEach((scenario) => {
    const li = document.createElement('li');
    const btn = document.createElement('button');

    btn.className = 'menu-btn';
    btn.textContent = scenario.label;
    btn.dataset.id = scenario.id;

    btn.addEventListener('click', () => loadScenario(scenario));

    li.appendChild(btn);
    menu.appendChild(li);
  });
});

// Inicializa com o primeiro cenário (Capa)
if (SCENARIOS.length > 0) {
  // Pequeno delay para garantir que o DOM esteja pronto
  setTimeout(() => loadScenario(SCENARIOS[0]), 100);
  snippetScriptPre();
}

/**
 * Função global para recarregar (botão do header)
 */
window.reloadCenario = () => {
  const currentWrapper = target?.querySelector('.cenario-wrapper');
  if (!currentWrapper) return;

  const cenarioId = currentWrapper.getAttribute('data-cenario-map');
  if (!cenarioId) return;

  // Lógica de reload simples
  target.innerHTML = '';
  setTimeout(() => {
    const wrapper = document.createElement('div');
    wrapper.className = 'cenario-wrapper';
    wrapper.dataset.cenarioMap = cenarioId;
    wrapper.style.minHeight = '500px';
    wrapper.style.position = 'relative';
    wrapper.innerHTML = 'Recarregando...';
    target.appendChild(wrapper);
  }, 50);
};
